module.exports = __webpack_public_path__ + "img/cEgbwuEB.a83bd945.svg";